module.exports = __webpack_public_path__ + "static/media/main-weapon.60416799.png";